import React from "react";
import { IoClose } from "react-icons/io5";
import { useAuthStore } from "../../context/useAuthStore";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constant/routes";
import logo from '../../assets/llb360.png'


interface LogoutModalProps {
  userName: string;
  showModal: boolean;
  onClose: () => void;
  onLogout: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
  showModal,
  onClose,
  onLogout,
}) => {

  const { user } = useAuthStore();

  if (!showModal) return null;
  
  return (
    <section
      className="modalSection"
      role="dialog"
      aria-modal="true"
      aria-labelledby="logout-title"
    >
      <div className="modalContainer">
        <button
          onClick={onClose}
          className="modalCloseButton"
          aria-label="Close modal"
        >
          <IoClose size={20} />
        </button>

        <div className="logoutModalBody">
          <Link to={ROUTES.DASHBOARD} className="flex justify-center w-full mb-4">
            <img src={logo} alt="LLB360 Logo" className="w-28" loading="lazy"/>
          </Link>
          <h2 id="logout-title" className="logoutModalTitle">
            Are you sure you want to logout?
          </h2>
          <p className="logoutModalDesc">
            Logged in as <span className="logoutModalUserName">{user?.fullName || "User"}</span>
          </p>
          <button
            onClick={onLogout}
            className="defaultButton"
          >
            Logout
          </button>
        </div>
      </div>
    </section>
  );
};

export default LogoutModal;